import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_INVOICE_CLIENT_LIST_DTE_LOADING = 'GET_INVOICE_CLIENT_LIST_DTE_LOADING';
export const GET_INVOICE_CLIENT_LIST_DTE_SUCCESS = 'GET_INVOICE_CLIENT_LIST_DTE_SUCCESS';
export const GET_INVOICE_CLIENT_LIST_DTE_REJECT  = 'GET_INVOICE_CLIENT_LIST_DTE_REJECT';
export const GET_INVOICE_CLIENT_LIST_DTE_RESET   = 'GET_INVOICE_CLIENT_LIST_DTE_RESET';

//* ACTIONS ------------------------------------------------
export const getInvoiceClientListDteLoading = () => ({ type: GET_INVOICE_CLIENT_LIST_DTE_LOADING });
export const getInvoiceClientListDteSuccess = (payload) => ({ type: GET_INVOICE_CLIENT_LIST_DTE_SUCCESS, payload });
export const getInvoiceClientListDteReject  = (payload) => ({ type: GET_INVOICE_CLIENT_LIST_DTE_REJECT,  payload });
export const getInvoiceClientListDteReset   = () => ({ type: GET_INVOICE_CLIENT_LIST_DTE_RESET });

//* REQUEST SERVICE ----------------------------------------
export const getInvoiceClientListDteRequest = async (params, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Invoices/web/GetInvoicesListDTE`, options);
};
